import React from 'react';
import { Outlet } from 'react-router-dom';

export const ReportsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-8">
        <Outlet />
      </div>
    </div>
  );
};
